import {
  type NavigateOptions,
  type URLSearchParamsInit,
  useLocation,
  // biome-ignore lint/style/noRestrictedImports: We're creating our wrapped useSearchParams version here
  useSearchParams as useRouterSearchParams,
} from "react-router-dom";

type SetSearchParams = (
  nextInit:
    | URLSearchParamsInit
    | ((prev: URLSearchParams) => URLSearchParamsInit),
  options?: NavigateOptions,
) => void;

export function useSearchParams(): [URLSearchParams, SetSearchParams] {
  const location = useLocation();
  const [searchParams, setSearchParams] = useRouterSearchParams();

  const customSetSearchParams = (
    nextInit?:
      | URLSearchParamsInit
      | ((prev: URLSearchParams) => URLSearchParamsInit),
    options?: NavigateOptions,
  ): void => {
    setSearchParams(nextInit, {
      ...options,
      state: { ...location.state },
    });
  };

  return [searchParams, customSetSearchParams];
}
